'use strict';

const FetchHandler = require('../../deal/frontend/FetchHandler');

const _includes = (container, value) => {
  if ([].includes) {
    return container.includes(value);
  }

  let returnValue = false;
  const pos = container.indexOf(value);
  if (pos >= 0) {
    returnValue = true;
  }
  return returnValue;
};

const displayCardsUserNeedsToClaimDeal = function(
  userTypes,
  cashBack,
  buttonSelector
) {
  const billingRecordTypes = cashBack
    ? cashBack.acceptableBillingRecordTypes
    : [];
  if (!userTypes || !userTypes.userConsentedTypes) {
    return null;
  }
  const userConsentedTypes = userTypes.userConsentedTypes;
  if (billingRecordTypes && billingRecordTypes.length) {
    const dealCardTypes = billingRecordTypes.reduce((arr, types) => {
      const { cardType } = types;
      if (cardType) {
        return arr.concat(cardType);
      }
      return arr;
    }, []);
    let typesNeeded = [];
    const inBoth = userConsentedTypes.filter(type =>
      _includes(dealCardTypes, type)
    );
    if (!inBoth.length && userConsentedTypes.length) {
      typesNeeded = dealCardTypes;
    }
    if (typesNeeded.length) {
      const container = $('.eligible-cards-container .message');
      container
        .find('.icon-alert')
        .after(window.I18n.t('js.modules.cash_back.to_claim'));
      container.addClass(typesNeeded.join(' '));
      $('.eligible-cards-container').show();
      $(buttonSelector).text(
        window.I18n.t('js.modules.cash_back.enroll_and_claim')
      );
    }
  }
};

const getUserBillingRecordTypes = function(cb, data) {
  const userBillingRecordTypesFetchHandler = new FetchHandler({
    successHandlers: [userTypes => cb(userTypes, data)],
    requestOpts: {
      credentials: 'include',
      method: 'get',
    },
    url: '/deals/proxy/user/valid_billing_record_types',
  });
  userBillingRecordTypesFetchHandler.send();
};

module.exports = {
  displayCardsUserNeedsToClaimDeal,
  getUserBillingRecordTypes,
};
